<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <vip-level-settings-table></vip-level-settings-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import vipLevelSettingsTable from './VIPLevelSettingsTable.vue'

  export default {
    name: 'vipLevelSettings',
    components: {vipLevelSettingsTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/viplevel/VIPLevelSettings.vue